import { useState } from "react";
import { signIn } from "../lib/auth-client.ts";

/** "Continue with Google" — kicks off the Better-Auth Google OAuth flow. */
export function GoogleButton({ label = "Continue with Google" }: { label?: string }) {
  const [loading, setLoading] = useState(false);

  async function handleGoogle() {
    setLoading(true);
    try {
      // Redirects to Google, then back to the admin home (access is re-checked).
      // Absolute URL: Better-Auth resolves a relative callbackURL against the API's
      // baseURL, which would land on api.currency-core.com (404). Use the admin origin.
      await signIn.social({ provider: "google", callbackURL: `${window.location.origin}/` });
    } catch {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleGoogle}
      disabled={loading}
      className="btn-google"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1Z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
        <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z" />
      </svg>
      {loading ? "Redirecting…" : label}
    </button>
  );
}

/** "or" divider used between social and credential auth. */
export function AuthDivider() {
  return (
    <div className="auth-divider">
      or
    </div>
  );
}
